/**
 * Offline support.
 *
 * The service worker is a plain runtime cache rather than a build-time precache manifest. A
 * precache list has to be generated by a build plugin and kept in step with the asset hashes; a
 * stale-while-revalidate cache over same-origin GETs gives the same practical result — the game
 * works offline after one visit and updates itself on the next — in about forty lines and with no
 * build coupling at all.
 *
 * The whole thing is best-effort. A registration failure, a browser without service workers, or a
 * page served from a context where they are disallowed are all non-events: the game runs anyway.
 */

export const SERVICE_WORKER_URL = 'sw.js';

export async function registerServiceWorker(base: string): Promise<boolean> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return false;
  // A service worker needs a secure context, which `localhost` and https both are; anything else
  // will reject, so do not bother asking.
  if (!globalThis.isSecureContext) return false;

  try {
    await navigator.serviceWorker.register(`${base}${SERVICE_WORKER_URL}`, { scope: base });
    return true;
  } catch {
    return false;
  }
}
